import {useEffect} from "react";

const NotFound = () => {
    useEffect(() => {
        document.getElementsByTagName("main")[0].classList.add("justify-content-center");
    }, []);
    return (
        <div className="row">
            <div className="col-12">
                <h1>Not Found Organization or Panel.</h1>
                <h3>This user does not have an assigned organization or panel.</h3>
                <h3>Notify administrator</h3>
            </div>
        </div>
    );
};
export default NotFound;
